





























































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({})
export default class SideNavigation extends Vue {
	@Prop()
	show!: boolean;

	@Emit("side-nav-toggled")
	emitSideNavToggled(toggledValue: boolean) {
		return toggledValue;
	}
}
